export enum ApiTagsEnum {
  GET_TODAY_GAMES = 'GET_TODAY_GAMES',
  GET_RECENT_GAMES = 'GET_RECENT_GAMES',
  GET_ONE_GAME = 'GET_ONE_GAME',
}
